import React from 'react';
import { BringzzText } from "@bringzz/components";

const ArticleTab = ({ posts, isAllCategory, onItemClick }) => {
    const renderPostItem = (post, index, section) => {
        if (isAllCategory) {
            return (
                <div key={`${section}-${post.id}-${index}`} className='flex items-center border-b py-2 cursor-pointer' onClick={() => onItemClick(post, 'post')}>
                    <BringzzText tag='h4'>{post.title}</BringzzText>
                </div>
            );
        }
        
        return (
            <div key={`${section}-${post.id}-${index}`} className='flex items-center border-b py-3 cursor-pointer' onClick={() => onItemClick(post, 'post')}>
                {post.postImage ? (
                    <img src={post.postImage} className='w-16 h-16 rounded mr-3 flex-shrink-0 object-cover' alt={post.title} />
                ) : (
                    <div className='w-16 h-16 bg-gray-300 rounded mr-3 flex-shrink-0'></div>
                )}
                <div className='flex flex-col flex-grow'>
                    <div className='flex items-center mb-1'>
                        {post.authorImage ? (
                            <img src={post.authorImage} className='w-5 h-5 rounded-full mr-2' alt={post.author} />
                        ) : null}
                        <BringzzText tag='h5' className='text-gray-600 mr-2'>{post.author || 'Author'}</BringzzText>
                        <BringzzText tag='h5' className='text-gray-400'>• {post.publishDate}</BringzzText>
                    </div>
                    <BringzzText tag='h4' className='font-medium'>{post.title}</BringzzText>
                </div>
            </div>
        );
    };

    return { renderPostItem };
};

export default ArticleTab;